import {PartialOptions} from 'overlayscrollbars';

// https://kingsora.github.io/OverlayScrollbars/

const osBase: PartialOptions = {
	scrollbars: {
		visibility: 'auto',
		autoHide: 'move',
		autoHideDelay: 400,
	}
}

export const osLight: PartialOptions = {
	scrollbars: {
		...osBase.scrollbars,
		theme: 'os-theme-light'
	}
}

export const osDark: PartialOptions = {
	scrollbars: {
		...osBase.scrollbars,
		theme: 'os-theme-dark'
	}
}
